import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
    ADMIN_MANAGE_PROSPECT_AUDIT,
    ADMIN_MANAGE_PROSPECT_ACTIVITY,
    ADMIN_MANAGE_PROSPECT_DETAILS,
    ADMIN_MANAGE_PROSPECT_MIGRATION,
    ADMIN_MANAGE_PROSPECT_USERS,
    ADMIN_PROSPECTS,
    atlas
} from '@lsq-frontend/fasttrack-shared/routing-atlas';
import { DrApplicationService, SchemaTypes } from '@lsqlabs/dr-application-shared';
import { ProspectService, SchemaService } from '@lsq-frontend/remote-services/ar-app';
import {
    forLifeOf,
    getDynamicRouteLink,
    getRouterLinkUrlById,
    LifecycleAware
} from '@lsq-frontend/common-ui';
import { getRouterLinkById } from '@lsq-frontend/common-ui';

@LifecycleAware()
@Component({
    selector: 'manage-prospect',
    templateUrl: './manage-prospect.component.html'
})
export class ManageProspectComponent {
    public tabsConfig$ = [];
    public loading = true;
    public schemaType: string;

    constructor(
        private _router: Router,
        private _activatedRoute: ActivatedRoute,
        private _prospectService: ProspectService,
        private _schemaService: SchemaService,
        private _arService: DrApplicationService
    ) {
        this._activatedRoute.params.pipe(forLifeOf(this)).subscribe(async (params) => {
            await this.fetchProspect(params?.prospectId);
            this.setTabsConfig(params?.prospectId);
        });
    }

    public async fetchProspect(prospectId: string): Promise<void> {
        try {
            const getProspect = this._prospectService.getProspectDataById(prospectId);
            const prospectData = await getProspect.toPromise();
            if (!prospectData) {
                return;
            }
            this._arService.setProspect(prospectData);
            const getProspectSchema = this._schemaService.getProspectSchema(
                prospectData.prospectSchemaId
            );
            const schemaData = await getProspectSchema.toPromise();
            this._arService.setProspectSchema(schemaData[0]);
            this.schemaType = schemaData[0].schemaType;

            this.initStages();
        } catch (e) {
            this.navigateToProspectsPage();
        }
        this.loading = false;
    }

    public initStages() {
        this._arService.initStages();
    }

    public setTabsConfig(prospectId: string): void {
        this.tabsConfig$ = [
            {
                label: 'Summary',
                routerLink: getDynamicRouteLink(
                    getRouterLinkUrlById(atlas, ADMIN_MANAGE_PROSPECT_DETAILS),
                    {
                        prospectId
                    }
                )
            }
        ];
        if (this.schemaType === SchemaTypes.ArProspect) {
            this.tabsConfig$.push(
                {
                    label: 'Activity',
                    routerLink: getDynamicRouteLink(
                        getRouterLinkUrlById(atlas, ADMIN_MANAGE_PROSPECT_ACTIVITY),
                        {
                            prospectId
                        }
                    )
                },
                {
                    label: 'Migration',
                    routerLink: getDynamicRouteLink(
                        getRouterLinkUrlById(atlas, ADMIN_MANAGE_PROSPECT_MIGRATION),
                        {
                            prospectId
                        }
                    )
                }
            );
        }
        if (
            this.schemaType === SchemaTypes.ArProspect ||
            this.schemaType === SchemaTypes.ScfBuyerProspect
        ) {
            this.tabsConfig$.push({
                label: 'Users',
                routerLink: getDynamicRouteLink(
                    getRouterLinkUrlById(atlas, ADMIN_MANAGE_PROSPECT_USERS),
                    {
                        prospectId
                    }
                )
            });
        }
        this.tabsConfig$.push({
            label: 'Audit',
            routerLink: getDynamicRouteLink(
                getRouterLinkUrlById(atlas, ADMIN_MANAGE_PROSPECT_AUDIT),
                {
                    prospectId
                }
            )
        });
    }

    public navigateToProspectsPage(): void {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._router.navigate(getRouterLinkById(atlas, ADMIN_PROSPECTS), {});
    }

    public getBusinessName(): string {
        return this._arService.getProspect()?.businessName;
    }
}
